module.exports = __webpack_public_path__ + "img/rain.8bdf47fe.png";